<template>
  <Card>
    <template slot="header">
      Non-Resident Gate Pass
    </template>
    <v-layout
      align-center
      justify-center
      row
      wrap>
      <v-flex>
        <h4>Standard</h4>
        Permits entry of one car into the park for the duration of a continuous visit.<br>
        <h4>Season</h4>
        Permits entry of one car into the park for the entire season.
      </v-flex>
    </v-layout>
    <v-layout
      align-center
      row
      wrap>
      <v-flex class="my-4">
        <ReserveBlock>
          <template slot="header">
            Standard<br>
            ${{ settings.gatePassPrice }}
          </template>
          <IconButton
            icon="fa-plus"
            color="blue"
            tooltip="Available"
            float
            @click="addPassToCart()"
          />
        </ReserveBlock>
      </v-flex>
      <v-flex class="my-4">
        <ReserveBlock>
          <template slot="header">
            {{ year }} Season<br>
            ${{ settings.gatePassSeasonPrice }}
          </template>
          <IconButton
            icon="fa-plus"
            color="blue"
            tooltip="Available"
            float
            @click="addPassToCart({year: year})"
          />
        </ReserveBlock>
      </v-flex>
    </v-layout>
  </Card>
</template>

<script>
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'
// our new component
export default {
  computed: {
    ...mapGetters({
      searchCriteria: 'facilities/searchCriteria',
      authenticated: 'person/authenticated'
    }),
    year () {
      return new Date(this.searchCriteria.date).getFullYear()
    }
  },
  methods: {
    ...mapActions({
      createGatePass: 'cart/createGatePass',
      newNotification: 'info/newNotification'
    }),
    addPassToCart (payload) {
      if (!this.authenticated) {
        this.newNotification({ message: 'You must be logged in to reserve.' })
      } else if (!this.assertSetting('campingOpen', 1) && !this.assertSetting('parkingOpen', 1)) {
        this.newNotification({ message: 'Online reservations are currently closed. Please call the office to make a reservation.' })
      } else {
        this.createGatePass(payload)
      }
    }
  }
}
</script>
